import {Injectable, signal} from '@angular/core';
import {Observable} from 'rxjs';
import {toObservable} from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class OdooService {

  private readonly _sessionId = signal<string>('');

  public readonly sessionId = this._sessionId.asReadonly();
  public readonly sessionId$: Observable<string> = toObservable(this._sessionId);

  public setSessionId(sessionId: string): void {
    this._sessionId.set(sessionId);
  }

  public getSessionId(): string {
    return this._sessionId();
  }

  public clearSessionId(): void {
    this._sessionId.set('');
  }

}
